document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById('make-offer-btn');
  const modal = document.getElementById('offer-modal');
  const form = document.getElementById('offer-form');
  if (!btn || !modal || !form) return;

  const closeBtn = modal.querySelector('.offer-modal__close');
  const bodyField = document.getElementById('contact-body');
  const offerText = form.querySelector('[name="offer_details"]');
  const skuField = document.getElementById('current-variant-sku');

  btn.addEventListener('click', () => {
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
  });

  closeBtn.addEventListener('click', () => {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  });

  modal.addEventListener('click', e => {
    if (e.target === modal) {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    }
  });

  form.addEventListener('submit', () => {
    // Product page link, keeping only the selected variant from the address bar
    const variant = new URLSearchParams(location.search).get('variant');
    const productLink = location.origin + location.pathname + (variant ? '?variant=' + variant : '');

    bodyField.value =
      `Offer for product: ${document.title}\n\n` +
      `Link: ${productLink}\n\n` +
      `SKU: ${skuField.value}\n\n` +
      `Offer details:\n${offerText.value}`;
  });
});